import Icons from "/src/features/phone/data/types/Icons"
export default [
    {
        value: "web",
        text: <span> <img srcSet={Icons["web"]}></img></span>,
    },
    {
        
        value: "telephony",
        text : <span> <img srcSet={Icons["telephony"]}></img> </span>        
    },
    {
        
        value: "rcs",
        text : <span> <img srcSet={Icons["rcs"]}></img> </span>        
    },
]